import React from 'react';

import { Maybe } from '@admin/schema';

import { Toggle } from './toggle';

export const StorageTermInput: React.FC<{
  included: boolean;
  storageTerm?: Maybe<number>;
  setIncluded(included: boolean): void;
  onChange(storageTerm?: number): void;
}> = ({ included, storageTerm, setIncluded, onChange }) => {
  const onToggle = (newIncluded: boolean) => {
    if (!newIncluded) {
      onChange(undefined);
    }
    setIncluded(newIncluded);
  };

  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newStorageTerm = event.currentTarget.value ? Number(event.currentTarget.value) : undefined;
    onChange(newStorageTerm);
  };

  return (
    <div className="form-group">
      <label className="control-label">Storage Commitment</label>
      <div className="row">
        <Toggle className="col-md-2" included={included} onToggle={onToggle} />
        <div className="col-md-2">
          {included && (
            <div className="input-group">
              <input type="number" className="form-control" value={storageTerm || ''} onChange={onInputChange} />
              <span className="input-group-addon">months</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
